import React from 'react';
import PortalModal from '../../../common/PortalModal/PortalModal';

export default function RoleAssignmentModal({ user, roles, onAssign, onRemove, onClose }) {
  if (!user) return null;

  const userRoles = user.roles || [];
  const availableRoles = roles.filter(role => !userRoles.includes(role.role_id));

  return (
    <PortalModal
      isOpen
      onClose={onClose}
      title={
        <>
          <i className="fas fa-user-tag"></i>
          Manage Roles
        </>
      }
      size="large"
      bodyClassName="rbac-modal-body"
    >
      <div className="modal-body">
          {/* User Info */}
          <div style={{ 
            padding: '1rem', 
            background: 'rgba(100, 181, 246, 0.1)', 
            borderRadius: '8px',
            marginBottom: '1.5rem',
            border: '1px solid rgba(100, 181, 246, 0.2)'
          }}>
            <div style={{ fontSize: '1rem', color: '#fff', fontWeight: '500' }}>
              <i className="fas fa-envelope" style={{ marginRight: '0.5rem', color: '#64b5f6' }}></i>
              {user.user_email || 'No email'}
            </div>
          </div>

          {/* Currently Assigned Roles */}
          <div className="form-group">
            <label>Assigned Roles ({userRoles.length})</label>
            {userRoles.length > 0 ? (
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '0.75rem' 
              }}>
                {userRoles.map(roleId => {
                  const role = roles.find(r => r.role_id === roleId);
                  return (
                    <div 
                      key={roleId}
                      style={{ 
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '1rem', 
                        background: 'rgba(255, 255, 255, 0.05)', 
                        borderRadius: '8px',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        gap: '1rem'
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: '600', marginBottom: '0.25rem', color: '#fff' }}>
                          {role?.role_name || roleId}
                        </div>
                        <div style={{ fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                          {role?.description || 'No description'}
                        </div>
                        {role?.policies && role.policies.length > 0 && (
                          <div style={{ fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.6)', marginTop: '0.5rem' }}>
                            <i className="fas fa-shield-alt"></i> {role.policies.length} {role.policies.length === 1 ? 'policy' : 'policies'}
                          </div>
                        )}
                      </div>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => onRemove(roleId)}
                        title="Remove Role"
                      >
                        <i className="fas fa-times"></i>
                        Remove
                      </button>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ 
                padding: '1rem', 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '8px',
                textAlign: 'center',
                color: 'rgba(255, 255, 255, 0.6)'
              }}>
                No roles assigned yet
              </div>
            )}
          </div>

          {/* Available Roles to Assign */}
          <div className="form-group" style={{ marginTop: '1.5rem' }}>
            <label>Available Roles ({availableRoles.length})</label>
            {availableRoles.length > 0 ? (
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '0.75rem',
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {availableRoles.map(role => (
                  <div 
                    key={role.role_id}
                    style={{ 
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '1rem', 
                      background: 'rgba(255, 255, 255, 0.05)', 
                      borderRadius: '8px',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      gap: '1rem'
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: '600', marginBottom: '0.25rem', color: '#fff' }}>
                        {role.role_name}
                      </div>
                      <div style={{ fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                        {role.description}
                      </div>
                      {role.policies && role.policies.length > 0 && (
                        <div style={{ fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.6)', marginTop: '0.5rem' }}>
                          <i className="fas fa-shield-alt"></i> {role.policies.length} {role.policies.length === 1 ? 'policy' : 'policies'}
                        </div>
                      )}
                    </div>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => onAssign(role.role_id)}
                      title="Assign Role"
                    >
                      <i className="fas fa-plus"></i>
                      Assign
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ 
                padding: '1rem', 
                background: 'rgba(255, 255, 255, 0.05)', 
                borderRadius: '8px',
                textAlign: 'center',
                color: 'rgba(255, 255, 255, 0.6)'
              }}>
                {roles.length === 0 ? 'No roles available. Create roles first.' : 'All available roles are already assigned'}
              </div>
            )}
          </div>
        </div>
    </PortalModal>
  );
}
